// extracted by mini-css-extract-plugin
module.exports = {"container":"Payment_container__121xX","form":"Payment_form__2WTFP","mercadopago":"Payment_mercadopago__19wHF","inactive":"Payment_inactive__167Ig"};